export const SKILLS = [
    {
        title:"Frontend",
        icon:"./assets/images/frontend-icon.png",
        skills: [
            {skill: "HTML5", percentage:"80%"},
            {skill: "CSS3 (Sass/SCSS)", percentage:"90%"},
            {skill: "JavaScript", percentage:"75%"},
            {skill: "React.js", percentage:"80%"},            
        ],
    },
    {
        title:"Backend",
        icon:"./assets/images/backend-icon.png",
        skills: [
            {skill: "Node.js", percentage:"70%"},
            {skill: "Express.js", percentage:"65%"},  
            {skill: "Spring Boot", percentage:"65%"}         
        ],
    },
    {
        title:"Tools",
        icon:"./assets/images/tools-icon.png",
        skills: [
            {skill: "Git & GitHub", percentage:"85%"},
            {skill: "Visual Studio Code", percentage:"75%"},
            {skill: "Webpack", percentage:"60%"},
            {skill: "Responsive Design", percentage:"70%"},    
            {skill: "Anaconda", percentage:"70%"}        
        ],
    },

    {
        "title": "Machine Learning",
        "icon": "./assets/images/machine-learning.png",
        "skills": [
            {"skill": "Python", "percentage": "80%"},
            {"skill": "TensorFlow", "percentage": "75%"},
            {"skill": "Keras", "percentage": "70%"},
            {"skill": "Scikit-learn", "percentage": "80%"},
            {"skill": "Pandas", "percentage": "85%"},
            {"skill": "NumPy", "percentage": "80%"},
            {"skill": "Matplotlib", "percentage": "70%"},
            {"skill": "Data Preprocessing", "percentage": "75%"},
            {"skill": "Model Evaluation", "percentage": "75%"},
            {"skill": "Feature Engineering", "percentage": "70%"}
        ]
    },
    {
        title:"Languages",
        icon:"./assets/images/languages.png",
        skills: [
            {skill: "Java", percentage:"70%"},
            {skill: "Python", percentage:"80%"},
            {skill: "JavaScript", percentage:"75%"},      
        ],
    },
    {
        title:"Soft Skills",
        icon:"./assets/images/soft-skills-icon.png",
        skills: [
            {skill: "Problem-solving", percentage:"80%"},
            {skill: "Collaboration", percentage:"85%"},
            {skill: "Attention to Details", percentage:"75%"},      
        ],
    },
]

export const WORK_EXPERIENCE = [
    {
        title: "Associate Software Engineer at Accenture Solutions Private Limited",
        date: "December 2023 - Present",
        responsibilities: [
            "Front-end development for the Minecraft Project, focusing on user interface design and interaction.",
            "Implemented validation protocols for data integrity and application reliability.",
            "Collaborated with teams to align front-end design with project goals.",
            "Used modern frameworks and technologies for feature deployment and maintainability."
            
        ]
    },
    {
        title: "Data Analyst Intern at Highradius Pvt Ltd",
        date: "June 2022 - September 2022",
        responsibilities: [
            "Applied Machine Learning algorithms to extract detailed insights from extensive datasets.",
            "Performed Exploratory Data Analysis to find patterns and correlations.",
            "Processed data for Machine Learning models and predictive analytics.",
            "Tested and validated model performance for accuracy and reliability."
          
        ]
    },
    {
        title: "Trainee in Spring Boot Java at Accenture Solutions Private Ltd",
        date: "October 2023 - December 2022",
        responsibilities: [
            "Delivered projects in Spring Boot and Java, demonstrating full-stack development skills.",
            "Implemented backend solutions with Spring Boot's core concepts.",
            "Collaborated in coding practices to maintain high code standards.",
            "Engaged in learning initiatives for the latest Java framework trends."    

        ],
    },
]





